import { useRequestEditEmployeePermissions } from '@/hooks/httpRequest';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button, DialogFooter } from '@/components/ui';
import { broadcastService } from '@/services';
import { useUserConnected } from '@/hooks';
import { notify } from '@/functions';
import { TFormData } from '.';

const FormEditOrAssignPermissionsFooter = () => {

  const { triggerEditPermissions, isLoadingEditPermissions } = useRequestEditEmployeePermissions();
  const { control, handleSubmit, setValue } = useFormContext<TFormData>();
  let _id = useWatch({ control, name: '_id' });
  const { userConnected } = useUserConnected();

  const handleOnClickBtnCancel = () =>
    broadcastService.modal.hide();

  const handleOnClickBtnSave = () =>
    handleSubmit(
      async data => {
        try {
          let notificationMessage = `Les permissions de ${data.username} on été mise à jour avec succès`;
          // call api          
          await
            triggerEditPermissions({
              permissions: data.roles.permissions,
              root: data.roles.root ?? false,
              userId: data._id,
              employee: true
            })
              .catch(error => { throw new Error(error?.internalMessage); });
          // Notify
          notify(notificationMessage);
          // Close modal
          broadcastService.modal.hide();
        } catch (error) {
          setValue('errorMessage', (error as Error)?.message);
        }
      }
    )();

  const isCurrentUser = userConnected?._id === _id;

  return (
    <DialogFooter>
      <div className='w-full flex'>
        <Button
          onClick={handleOnClickBtnCancel}
          disabled={isLoadingEditPermissions}
          variant='secondary'
          className='mr-auto'
          type='button'
          size={'sm'}>
          Fermer
        </Button>
        {
          !isCurrentUser &&
          <Button
            onClick={handleOnClickBtnSave}
            disabled={isLoadingEditPermissions}
            type='button'
            size={'sm'}>
            Enregistrer
          </Button>
        }
      </div>
    </DialogFooter>
  );

};

export default FormEditOrAssignPermissionsFooter;
